import Lenis from '@studio-freight/lenis';
import { SCROLL } from '../app.config.js';
export default class Scroller {

  constructor() {
    SCROLL && this.init();
  }

  init() {
    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      this.lenis.raf(time);
      requestAnimationFrame(raf.bind(this));
    }

    requestAnimationFrame(raf.bind(this));

    this.lenis.on('scroll', ({ scroll, direction }) => {
      if (!document.body.classList.contains('_main-nav')) {
        if (scroll > 0) {
          document.body.classList.add('_scrolled')
        } else {
          document.body.classList.remove('_scrolled')
        }
  
        if (scroll > 600 && direction === 1) {
          document.body.classList.add('_sticky')
        } else {
          document.body.classList.remove('_sticky')
        }
      }
     
    });
  }

  start() {
    this.lenis.start();
  }

  stop() {
    this.lenis.stop();
  }

  toggle() {
    this.lenis.isStopped ? this.lenis.start() : this.lenis.stop();
  }

  scrollTo(n, immediate) {
    this.lenis.scrollTo(n, { immediate: immediate });
  }
}
